// NATIVE 
import React from 'react';

// INSTALLED 
import { Link } from 'react-router-dom'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import { ITitlesAndBreadcrumbs } from '../../commons/interfaces/titleAndBreadcrumds.interface';
import { IconByString } from '../IconByString';

// CUSTOM 




export const BreadCrumbsAndTitle = ({ title, mainModule, parent, action, icon  }:ITitlesAndBreadcrumbs) => {
  return (

    <>
        <div style={{ marginTop: 15 }}></div>
        
        
        <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
          {icon && <IconByString iconName={icon} sx={{ color: 'primary.main', fontSize: 35, padding: '8px', background: '#e0dee5', borderRadius: '50%' }} /> }
          {title} 
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>{mainModule}</Typography>

        {
          action != '' && <Link color="inherit" to={action}>
                              {parent} 
                          </Link>
        }
        <Typography color="textPrimary">{title}</Typography>
        </Breadcrumbs> 
        
    </>
   
  )
}
